import React, { useState } from 'react';

import { removeDevice } from '~/src/api/watch-everywhere';

import Popup from './popup';
import * as ST from './styled';

const DeviceCard = ({ device, accessTokenWatchEverywhere }) => {
    const [isDeleted, setIsDeleted] = useState(false);
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [errorText, setErrorText] = useState(null);

    const onRemove = () => {
        removeDevice({ accessTokenWatchEverywhere, deviceId: device.id })
            .then(result => {
                if (result.isDeleted) {
                    setIsDeleted(true);
                    setIsPopupOpened(false);
                } else {
                    setErrorText(result.message);
                }
            });
    };

    const onPopupClose = () => {
        setIsPopupOpened(false);
        setErrorText(null);
    };

    if (!isDeleted && device.title) {
        return (
            <ST.Wrapper>
                <ST.Title>{device.title}</ST.Title>

                {
                    !device.is_unbindable &&
                    <ST.Cross
                        onClick={() => setIsPopupOpened(true)}
                    />
                }

                <Popup
                    errorText={errorText}
                    isPopupOpened={isPopupOpened}
                    onClose={onPopupClose}
                    onRemove={onRemove}
                />
            </ST.Wrapper>
        );
    }

    return null;
};

export default DeviceCard;
